import { Button, Layout, theme, Form, Input, Spin, notification, Radio, Select, TimePicker } from "antd";

import React, { useEffect, useState, useCallback } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import TextArea from "antd/es/input/TextArea";
import StorageSuggestionApi from "../../common/Apis/StorageListApi";
import { AudioOutlined, LoadingOutlined } from "@ant-design/icons";
import DepartmentDropdown from "../../common/DropDowns/Department";
import SensorsStockPage from "../../common/DropDowns/Stock/SensorsStockPage";
import dayjs from 'dayjs';
import ReportsApi from "../../common/Apis/ReportsApi";

const EditStorageList = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { Content } = Layout;
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get("id");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);
  const [hotHoldConfigId, setHotHoldConfigId] = useState(null);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [SelectForm, SetSelectForm] = useState(null);
  
  const getSingleStorage = useCallback(() => {
    StorageSuggestionApi.Singlestorage(id)
      .then((response) => {
        const payload = response?.payload || response?.data || response;
        
        const isHot = payload?.hot === true || (payload?.hotHoldStorageConfigList && payload?.hotHoldStorageConfigList.length > 0);
        SetSelectForm(isHot ? 'Hot' : 'Cold');
        
        const formValues = {
          name: payload?.name,
          description: payload?.description,
          temperatureMaxInCelsius: payload?.temperatureMaxInCelsius,
          temperatureMinInCelsius: payload?.temperatureMinInCelsius,
          trigger: payload?.alertTrigger,
          institutionId: payload?.institutionDTO?.id,
          SensorID: (payload?.sensorDTOList && payload?.sensorDTOList.length > 0) ? payload?.sensorDTOList[0]?.id : null,
        };

        if (isHot && payload?.hotHoldStorageConfigList && payload?.hotHoldStorageConfigList.length > 0) {
          const hotConfig = payload.hotHoldStorageConfigList[0];
          setHotHoldConfigId(hotConfig.id);
          
          const operatingDays = hotConfig.operatingDays ? hotConfig.operatingDays.split(',') : [];
          
          const openingTime = hotConfig.openingTimeMinutes !== undefined && hotConfig.openingTimeMinutes !== null 
            ? dayjs().hour(Math.floor(hotConfig.openingTimeMinutes / 60)).minute(hotConfig.openingTimeMinutes % 60) 
            : null;
          
          const closingTime = hotConfig.closingTimeMinutes !== undefined && hotConfig.closingTimeMinutes !== null 
            ? dayjs().hour(Math.floor(hotConfig.closingTimeMinutes / 60)).minute(hotConfig.closingTimeMinutes % 60) 
            : null;
          
          formValues.operatingDays = operatingDays;
          formValues.openingTime = openingTime;
          formValues.closingTime = closingTime;
          formValues.checkFrequency = hotConfig.checkFrequencyMinutes;
        }

        form.setFieldsValue(formValues);
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Error",
          description: "Failed to load storage data",
          duration: 3,
        });
      });
  }, [id, form]);

  useEffect(() => {
    getSingleStorage();
  }, [getSingleStorage]);

  const handleSubmit = (data) => {
    setLoadings(true);
    
    const formatTimeToMinutes = (time) => {
      if (!time) return null;
      const hours = time.hour();
      const minutes = time.minute();
      return hours * 60 + minutes;
    };

    let formData = JSON.stringify({
      id: id,
      name: data?.name,
      alertTrigger: data?.trigger,
      description: data?.description,
      temperatureMaxInCelsius: SelectForm === "Hot" ? 0 : data?.temperatureMaxInCelsius,
      temperatureMinInCelsius: SelectForm === "Hot" ? 0 : data?.temperatureMinInCelsius,
      sensorDTOList: data.SensorID ? [{ id: data.SensorID }] : null,
      hot: SelectForm === "Hot" ? true : false,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
      institutionDTO: {
        id: data?.institutionId,
      },
    });

    StorageSuggestionApi.Putstorage(id, formData)
      .then((response) => {
        if (SelectForm === "Hot" && data?.operatingDays && data?.operatingDays.length > 0 && 
            data?.openingTime && data?.closingTime && data?.checkFrequency) {
          
          const operatingDays = data.operatingDays.join(',');
          
          const hotHoldConfigData = {
            storageDTO: {
              id: parseInt(id)
            },
            operatingDays: operatingDays,
            openingTimeMinutes: formatTimeToMinutes(data.openingTime),
            closingTimeMinutes: formatTimeToMinutes(data.closingTime),
            checkFrequencyMinutes: data.checkFrequency
          };

          if (hotHoldConfigId) {
            ReportsApi.UpdateDashboardHotHoldConfig(hotHoldConfigId, hotHoldConfigData)
              .then(() => {
                setLoadings(false);
                notification.open({
                  message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
                  description: "Storage and Hot Hold Configuration updated successfully",
                  closeIcon: false,
                  duration: 3,
                  style: {
                    backgroundColor: "#b3ffb3",
                    color: "green",
                  },
                });
                return navigate("/masters/storage");
              })
              .catch((err) => {
                setLoadings(false);
                console.error("Hot Hold Config Update Error:", err);
                notification.open({
                  message: <span style={{ fontWeight: "bold" }}>Warning</span>,
                  description: "Storage updated but Hot Hold configuration failed. Please try again.",
                  closeIcon: false,
                  duration: 5,
                  style: {
                    backgroundColor: "#fff7e6",
                    color: "#d48806",
                  },
                });
                return navigate("/masters/storage");
              });
          } else {
            ReportsApi.SaveDashboardHotHoldConfig(hotHoldConfigData)
              .then(() => {
                setLoadings(false);
                notification.open({
                  message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
                  description: "Storage and Hot Hold Configuration updated successfully",
                  closeIcon: false,
                  duration: 3,
                  style: {
                    backgroundColor: "#b3ffb3",
                    color: "green",
                  },
                });
                return navigate("/masters/storage");
              })
              .catch((err) => {
                setLoadings(false);
                console.error("Hot Hold Config Create Error:", err);
                notification.open({
                  message: <span style={{ fontWeight: "bold" }}>Warning</span>,
                  description: "Storage updated but Hot Hold configuration failed. Please try again.",
                  closeIcon: false,
                  duration: 5,
                  style: {
                    backgroundColor: "#fff7e6",
                    color: "#d48806",
                  },
                });
                return navigate("/masters/storage");
              });
          }
        } else {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
            description: "Storage updated successfully",
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#b3ffb3",
              color: "green",
            },
          });
          return navigate("/masters/storage");
        }
      })
      .catch((err) => {
        setLoadings(false);
        if (err.apiError?.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        } else {
          notification.error({
            message: "Error",
            description: "Failed to update storage",
            duration: 3,
          });
        }
      });
  };

  const [isRecording, setIsRecording] = useState(false);
  const [isRecording2, setIsRecording2] = useState(false);
  
  const startRecording = (fieldN) => {
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = 'en-US';
    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      let fieldName = fieldN;
      form.setFieldsValue({
        [fieldName]: transcript,
      });
    };
    recognition.start();
    if (fieldN === 'temperatureMinInCelsius') {
      setIsRecording(true);
    } else if (fieldN === 'temperatureMaxInCelsius') {
      setIsRecording2(true);
    }
  };

  const stopRecording = () => {
    setIsRecording(false);
    setIsRecording2(false);
  };

  const handleChangeModify = (item) => {
    SetSelectForm(item);
    if (item === 'Hot') {
      form.setFieldsValue({
        temperatureMinInCelsius: undefined,
        temperatureMaxInCelsius: undefined,
      });
    } else {
      form.setFieldsValue({
        operatingDays: undefined,
        openingTime: undefined,
        closingTime: undefined,
        checkFrequency: undefined,
      });
    }
  };

  const dayOptions = [
    { label: 'Monday', value: 'MONDAY' },
    { label: 'Tuesday', value: 'TUESDAY' },
    { label: 'Wednesday', value: 'WEDNESDAY' },
    { label: 'Thursday', value: 'THURSDAY' },
    { label: 'Friday', value: 'FRIDAY' },
    { label: 'Saturday', value: 'SATURDAY' },
    { label: 'Sunday', value: 'SUNDAY' },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            form={form}
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={24} md={24} className="pb-3">
                  <div className="d-flex">
                    <Radio
                      style={{ paddingRight: '30px' }}
                      checked={SelectForm === "Cold"}
                      onChange={() => handleChangeModify("Cold")}
                    >
                      Cold Unit
                    </Radio>
                    <Radio
                      checked={SelectForm === "Hot"}
                      onChange={() => handleChangeModify("Hot")}
                    >
                      Hot Unit
                    </Radio>
                  </div>
                </Col>
                
                <Col lg={8} md={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Name",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                
                <Col lg={8} md={12} className={SelectForm === "Hot" ? 'd-none' : ''}>
                  <Form.Item
                    name="temperatureMinInCelsius"
                    label="Temperature Min Celsius"
                    className="text-lable"
                    rules={SelectForm === "Cold" ? [
                      {
                        required: true,
                        message: "Please enter Temperature Min Celsius",
                      },
                    ] : []}
                  >
                    <Input
                      type="number"
                      placeholder="0"
                      className="control-input col-8"
                      style={{
                        border: 'none',
                        textAlign: 'end',
                        padding: '0px'
                      }}
                      addonAfter={
                        <>
                          <Button
                            className="StockTempClass"
                            style={{
                              border: 'none',
                              padding: 0,
                              paddingTop: '0px',
                              margin: 0,
                              background: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            'C
                          </Button>
                          <Button
                            onMouseDown={() => startRecording('temperatureMinInCelsius')}
                            onMouseUp={stopRecording}
                            onMouseLeave={stopRecording}
                            style={{
                              border: 'none',
                              padding: 0,
                              margin: 0,
                              marginLeft: '10px',
                              paddingLeft: '5px',
                              paddingBottom: '5px',
                              background: 'none',
                              borderRadius: '0px',
                              borderLeft: '1px solid #d9d9d9',
                              cursor: 'pointer',
                            }}
                          >
                            {isRecording ? <LoadingOutlined /> : <AudioOutlined />}
                          </Button>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
                
                <Col lg={8} md={12} className={SelectForm === "Hot" ? 'd-none' : ''}>
                  <Form.Item
                    name="temperatureMaxInCelsius"
                    label="Temperature Max Celsius"
                    className="text-lable"
                    rules={SelectForm === "Cold" ? [
                      {
                        required: true,
                        message: "Please enter Temperature Max Celsius",
                      },
                    ] : []}
                  >
                    <Input
                      type="number"
                      placeholder="0"
                      className="control-input col-8"
                      style={{
                        border: 'none',
                        textAlign: 'end',
                        padding: '0px'
                      }}
                      addonAfter={
                        <>
                          <Button
                            className="StockTempClass"
                            style={{
                              border: 'none',
                              padding: 0,
                              paddingTop: '0px',
                              margin: 0,
                              background: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            'C
                          </Button>
                          <Button
                            onMouseDown={() => startRecording('temperatureMaxInCelsius')}
                            onMouseUp={stopRecording}
                            onMouseLeave={stopRecording}
                            style={{
                              border: 'none',
                              padding: 0,
                              margin: 0,
                              marginLeft: '10px',
                              paddingLeft: '5px',
                              paddingBottom: '5px',
                              background: 'none',
                              borderRadius: '0px',
                              borderLeft: '1px solid #d9d9d9',
                              cursor: 'pointer',
                            }}
                          >
                            {isRecording2 ? <LoadingOutlined /> : <AudioOutlined />}
                          </Button>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12} className={SelectForm === "Cold" ? 'd-none' : ''}>
                  <Form.Item
                    name="operatingDays"
                    label="Operating Days"
                    className="text-lable"
                    rules={SelectForm === "Hot" ? [
                      {
                        required: true,
                        message: "Please select at least one operating day",
                      },
                    ] : []}
                  >
                    <Select
                      mode="multiple"
                      className="control-Select mb-1"
                      placeholder="Select Operating Days"
                      options={dayOptions}
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12} className={SelectForm === "Cold" ? 'd-none' : ''}>
                  <Form.Item
                    name="openingTime"
                    label="Opening Time"
                    className="text-lable"
                    rules={SelectForm === "Hot" ? [
                      {
                        required: true,
                        message: "Please select opening time",
                      },
                    ] : []}
                  >
                    <TimePicker
                      className="control-input"
                      placeholder="Select Opening Time"
                      format="HH:mm"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12} className={SelectForm === "Cold" ? 'd-none' : ''}>
                  <Form.Item
                    name="closingTime"
                    label="Closing Time"
                    className="text-lable"
                    rules={SelectForm === "Hot" ? [
                      {
                        required: true,
                        message: "Please select closing time",
                      },
                    ] : []}
                  >
                    <TimePicker
                      className="control-input"
                      placeholder="Select Closing Time"
                      format="HH:mm"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12} className={SelectForm === "Cold" ? 'd-none' : ''}>
                  <Form.Item
                    name="checkFrequency"
                    label="Check Frequency (minutes)"
                    className="text-lable"
                    rules={SelectForm === "Hot" ? [
                      {
                        required: true,
                        message: "Please enter check frequency",
                      },
                      {
                        type: 'number',
                        min: 1,
                        message: "Frequency must be at least 1 minute",
                      },
                    ] : []}
                  >
                    <Input
                      type="number"
                      placeholder="Enter minutes (e.g., 60 for every hour)"
                      className="control-input"
                      min={1}
                      step={1}
                      addonAfter="minutes"
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value !== '' && !isNaN(value) && Number(value) >= 0) {
                          form.setFieldsValue({
                            checkFrequency: Number(value)
                          });
                        }
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col lg={8} md={12}>
                  <DepartmentDropdown />
                </Col>
                
                <Col lg={8} md={12} className={SelectForm === "Hot" ? 'd-none' : ''}>
                  <SensorsStockPage SensprValid={SelectForm === "Hot" ? false : true} />
                </Col>
                
                <Col lg={8} md={8}>
                  <Form.Item
                    name="trigger"
                    label="Want to trigger an alert"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Trigger",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Trigger"
                    >
                      <Select.Option value={true}>
                        Yes
                      </Select.Option>
                      <Select.Option value={false}>
                        No
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                
                <Col lg={20} md={12}>
                  <Form.Item
                    name="description"
                    label="Description"
                    className="text-lable mt-2"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Description",
                      },
                    ]}
                  >
                    <TextArea
                      placeholder="Description"
                      className="form-control control-input p-3"
                      rows={3}
                      style={{ resize: "none" }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5" style={{ gap: "10px" }}>
                <Button
                  onClick={handleGoBack}
                  style={{
                    height: 40,
                    borderRadius: 6,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                    textDecoration: "none",
                    fontWeight: 500,
                    padding: "0 20px",
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    height: 40,
                    borderRadius: 6,
                    fontWeight: 500,
                    padding: "0 20px",
                  }}
                >
                  Update {loadings && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
      </Layout>
    </Layout>
  );
};

export default EditStorageList;